import { Document, Page } from '@react-pdf/renderer';
import { UsageLogs } from '../../components';
import { UsageProduct } from '../../../usage/interfaces/usage-product.interface';
import { styles } from './UsageLogsPDF.module';

interface CreditNotePDFProps {
  usageProduct: UsageProduct;
  isSample?: boolean;
  isPreview?: boolean;
}

export const UsageLogsPDF = ({ usageProduct, isSample, isPreview }: CreditNotePDFProps) => {
  return (
    <Document>
      <UsageLogs usageReportsByProduct={[usageProduct]} isSample={isSample} isPreview={isPreview} />
    </Document>
  );
};
